import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validators, FormControl, FormGroup, FormBuilder} from '@angular/forms';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {tap, map, concatMap} from 'rxjs/operators';
import {MergeQuestiondataService} from 'src/app/project/services/merge-questiondata.service';
//import {  IQuestionMeta, ,} from '../question-item.model';
import {ResponseLoadQuestionContent} from 'src/app/project/services/project-openapi-cast/project-openapi-cast.model';

import {FC_QIR, FIELDWIDTH, IAllFieldItems, IRow, IRowContent, ISROWORCOLUMN} from './row.model'
import {IFieldItem, IFunction, ITEMTYPE, ROWPOSITION } from 'src/app/shared/components/field-item/field-item.model'

@Component({
   selector: 'app-field-item-row',
   templateUrl: './field-item-row.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => FieldItemRowComponent)
      },
      {
         provide: NG_VALIDATORS,
         useExisting: forwardRef(() => FieldItemRowComponent),
         multi: true
      }
   ],
   changeDetection: ChangeDetectionStrategy.OnPush,
   standalone: false
})
export class FieldItemRowComponent implements ControlValueAccessor, Validators, OnDestroy, OnInit {
   public ITEMTYPE: typeof ITEMTYPE = ITEMTYPE;
   public FIELDWIDTH: typeof FIELDWIDTH = FIELDWIDTH;
   public FC_QIR = FC_QIR; 

   private done_: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   public done$: Observable<boolean> = this.done_.asObservable();

   public rowFormGroup: FormGroup = this.fb.group({});

   public fieldItem: IFieldItem = {} as IFieldItem;
   public rowItem: IRow = {} as IRow;

   private metaData_: IAllFieldItems = {} as IAllFieldItems;
   
   @Output() public valueFunction: EventEmitter<IFunction> = new EventEmitter<IFunction>();
   
   public isRequiredM: boolean = false;
  
   @Input()
   set fieldMeta (val: IAllFieldItems) {
      this.reset();
      if (!val) return;
      this.metaData_ = val;
   }

   get fieldMeta (): IAllFieldItems {
      return this.metaData_ as IAllFieldItems;
   }


   @Input()
   set value (val: IRowContent) {
      if (this.rowFormGroup) this.rowFormGroup.get(FC_QIR.ROW)?.setValue(val.content);
   }

   get value (): IRowContent {
      return {content: !this.rowFormGroup.get(FC_QIR.NODATA)?.value ? this.rowFormGroup.get(FC_QIR.ROW)?.value : "", send: <boolean>this.rowItem.send, noData: this.rowFormGroup.get(FC_QIR.NODATA)?.value ?? false};
   }

   constructor (private fb: FormBuilder, private cdRef: ChangeDetectorRef, public sMergeQuestiondata: MergeQuestiondataService)  { }

   ngOnInit (): void {
      this.sMergeQuestiondata.loadQuestionMetaData({id: this.metaData_.id, question_id: this.fieldMeta.question_id}).pipe(
         tap((value: ResponseLoadQuestionContent) => this.rowItem = value.isroworcolumn ? {...(value as IRow), isroworcolumn: value.isroworcolumn === ISROWORCOLUMN.column ? ROWPOSITION.column : ROWPOSITION.row} : value as IRow),
         tap((value: ResponseLoadQuestionContent) => this.fieldItem = value as IFieldItem),
         concatMap(_ => this.initializeFormGroup())
      ).subscribe((_: boolean) => {
         if (!this.rowItem.send) this.onTouched();
         this.done_.next(true);
         this.cdRef.detectChanges();
      });
   }

   ngOnDestroy (): void {
      this.reset();
   }

   validate (_control: AbstractControl): ValidationErrors | null {
      this.rowFormGroup.updateValueAndValidity({emitEvent: true, onlySelf: true});
      return this.rowFormGroup.invalid ? {invalid: true} : null;
   }

   writeValue (value: string): void {
      if (this.metaData_.fieldtype?.toLocaleLowerCase() == ITEMTYPE.toggle) this.rowFormGroup.get(FC_QIR.ROW)?.setValue(value);
   }
   
   registerOnChange (fn: any): void {
      this.onChange = fn;
   }

   registerOnTouched (fn: any): void {
      this.onTouched = fn;
   }

   private onTouched () {}

   private onChange (_: IRowContent) {}

   public onValidationChange: any = () => {};

   public registerOnValidatorChange? (fn: ()=> void): void {
      this.onValidationChange = fn;
   }

   setDisabledState (isDisabled: boolean | undefined): void {
      isDisabled ? this.rowFormGroup.disable() : this.rowFormGroup.enable();
   }

   private reset (): void {
      this.done_.next(false);
      this.rowFormGroup = this.fb.group({});
      this.fieldItem = {} as IFieldItem;
      this.metaData_ = {} as IAllFieldItems;
      this.rowItem = {} as IRow;
   }

   private initializeFormGroup (): Observable<boolean> {
      this.rowFormGroup.addControl(FC_QIR.NODATA, new FormControl(''));
      this.rowFormGroup.get(FC_QIR.NODATA)?.valueChanges.subscribe(value => {
         this.setIQuestionItemDisabled(value);
         this.value.noData = value;
         this.onChange(this.value);
         this.onTouched();
      });

      this.rowFormGroup.addControl(FC_QIR.ROW, new FormControl(''));
      this.rowFormGroup.get(FC_QIR.ROW)?.valueChanges.subscribe(_ => {
         this.value.noData = false;
         this.onChange(this.value);
         this.onTouched();
      });

      this.rowFormGroup.get(FC_QIR.ROW)?.setValue('');
      this.cdRef.detectChanges();

      return of(true);
   }

   private setIQuestionItemDisabled (isDisabled: boolean | undefined): void {
      if (isDisabled) this.rowFormGroup.get(FC_QIR.ROW)?.setValue('', {emit: false});
      isDisabled ? this.rowFormGroup.get(FC_QIR.ROW)?.disable() : this.rowFormGroup.get(FC_QIR.ROW)?.enable();
      
   }

   public setRequired (value: boolean) {
      this.isRequiredM = value;
      this.cdRef.detectChanges();
   }

   public setValueFunction (value: IFunction) {
      this.valueFunction.emit(value);
   }
}
